/**
 * ProfessionalsV3 — scaffold shell
 * Flag: professionalsV3
 * API: api/v3/professionals (stub returning { message: 'ProfessionalsV3 stub' })
 * TODO: Replace stub with HCP search + details RTK Query endpoints and AG Grid
 */
import React from 'react';
import { useGetProfessionalsV3Query } from '../../api/professionalsV3Api';

export default function ProfessionalsV3() {
    const { data, isLoading, isError } = useGetProfessionalsV3Query();

    if (isLoading) return <p>Loading…</p>;
    if (isError)   return <p>Error loading Professionals.</p>;

    return (
        <main aria-label="Professionals v3 (scaffold)">
            <p>ProfessionalsV3 scaffold — {JSON.stringify(data)}</p>
        </main>
    );
}
